import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ShareButton from 'Components/ComponentLibrary/Components/Buttons/ShareButton';

const styles = () => ({
  root: {},
});

const ShareRescheduleMeetingLinkButton = ({
  className,
  classes,
  onClick,
  disabled,
}) => {
  return (
    <ShareButton
      className={classNames(classes.root, className)}
      title="Share Reschedule Meeting Link"
      onClick={onClick}
      size="small"
      disabled={disabled}
    />
  );
};

ShareRescheduleMeetingLinkButton.defaultProps = {
  className: '',
};

ShareRescheduleMeetingLinkButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.func.isRequired,
};

export default withStyles(styles)(ShareRescheduleMeetingLinkButton);
